// ----------------------------------------------------------------------
import Chip from "@mui/material/Chip";

export function fText(string) {
	return string
		? string
				?.toLowerCase()
				?.split(" ")
				?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				?.join(" ")
		: "N/A";
}

export function fMobileNumber(Number) {
	const countryCode = "+91";
	const formattedNumber = `${countryCode} ${Number?.slice(0, 5)}  ${Number?.slice(5)}`;
	return formattedNumber;
}

export function truncateWords(text, maxChars) {
	if (text?.length <= maxChars) return text;
	return text?.substring(0, maxChars) + "...";
}

export function getTypeCommentsBadge(type) {
	switch (type) {
		case true:
			return <Chip label="📍 Zipcode" variant="" color="primary" />;
		default:
			return <Chip label="🏘️ Street" variant="" color="info" />;
	}
}

export function getAddressBadge(type) {
	switch (type) {
		case true:
			return <Chip label="Manual" variant="" color="primary" />;
		default:
			return <Chip label="Google" variant="" color="info" />;
	}
}
export function getStatusBadge(status, flagged) {
	if (flagged) {
		return <Chip label="Flagged" variant="" color="error" />;
	}
	switch (status) {
		case false:
			return <Chip label="Fresh" variant="" color="primary" />;
		case true:
			return <Chip label="Historic" variant="" color="warning" />;
		default:
			return <Chip label="Unknown" variant="" color="darker" />;
	}
}

export function getActivityActionBadge(action) {
	if (action === "UPDATE") {
		return <Chip label="Update" variant="" color="warning" />;
		// return <span className="badge badge-warning">Update</span>;
	} else if (action === "SOFT_DELETE") {
		return <Chip label="Delete" variant="" color="error" />;
		// return <span className="badge badge-danger">Delete</span>;
	} else if (action === "CREATE") {
		return <Chip label="Create" variant="" color="primary" />;
		// return <span className="badge badge-success">Create</span>;
	}
	return null;
}
